import React from 'react';

import { VERIFICATION_PRE_SORTIE_TEXT } from './constants';

import './VerificationPreSortie.less';

interface VerificationPreSortieProps {
  children?: React.ReactNode;
}

const VerificationPreSortie = ({
  children,
}: VerificationPreSortieProps): React.ReactElement => {
  return (
    <div className="verification-pre-sortie">
      <p>{VERIFICATION_PRE_SORTIE_TEXT}</p>
      {children}
    </div>
  );
};

export default VerificationPreSortie;
